const yue = {
    common: {
        view: "查看",
        backHome: "返回首頁",
        backToPanel: "返回後台",
        menu: "選單",
        email: "電郵",
        clear: "清空",
        submit: "提交",
        go: "前往",
        copyLink: "複製連結",
        share: "分享",
        copyright: "©{year} by Hei Creative.",
        days: "{count} 天",
        networkTroubleshootHint: "請嘗試清理快取 / 切換網絡 / 使用預設瀏覽器打開。",
        scrollNav: "快速滾動",
        scrollToTop: "返回頂部",
        scrollToBottom: "滾動到底部",
        redTitle: "小红书 The Red",
        instagramTitle: "Instagram",
    },
    language: {
        label: "語言",
        zh: "简体",
        en: "English",
        yue: "繁體",
    },
    nav: {
        about: "關於我們",
        portfolio: "作品集",
        photography: "攝影服務",
        creatorPartnerships: "博主合作",
        contact: "聯絡我們",
        portrait: "人像",
        wedding: "婚禮",
        event: "大型活動",
        commercial: "展會",
        pets: "寵物",
        fashion: "時尚",
        destination: "旅拍",
        creative: "創意",
        scenery: "風光",
    },
    home: {
        portrait: "人像",
        wedding: "婚紗照",
        event: "大型活動",
        commercial: "展會",
        pets: "寵物",
        fashion: "時尚",
        destination: "旅拍",
        creative: "創意",
        scenery: "風光",
    },
    pages: {
        about: {
            title: "關於我們 | About Us",
            intro: "我哋係一間專注於**影像拍攝同品牌內容合作**嘅綜合傳媒公司，紮根英國，用專業嘅影像能力同優質嘅創作者資源，為個人、機構同品牌提供多元化嘅視覺內容同傳播服務。",
            focusAreas: [
                { label: "**影像拍攝服務**", text: "覆蓋商業活動、品牌內容、人物肖像、婚禮婚紗、旅拍生活及時尚影像等多元場景。" },
                { label: "**品牌內容合作**", text: "連接各大平台頭部創作者同品牌，提供商業推廣、內容共創同線下活動等多元合作。" },
            ],
            photography: {
                title: "影像拍攝服務 | Photography Service",
                moreLink: "了解更多",
                lead: "我哋擁有英國業內領先嘅專業影像團隊同豐富嘅大型活動拍攝經驗。核心團隊成員曾經：",
                highlights: [
                    "擔任 **2026全英春晚主攝影師**，並獲選為 **2026倫敦馬拉松（世界田聯白金賽事）官方攝影團隊唯一中國大陸籍攝影師**；",
                    "為包括**中國駐英國大使**在內嘅多位國際政要拍攝新聞影像；",
                    "深度參與**紀念抗戰勝利80週年英國音樂會、倫敦時裝週、哈佛中國創新投資論壇、文旅部倫敦新春遊園會**等大型活動嘅視覺影像記錄；",
                    "攝影作品多次被**《中國日報》、中新網**等權威央媒刊發同採用。",
                ],
                summary: "憑藉專業嘅影像團隊同豐富嘅現場製作經驗，我哋提供覆蓋**會議、會展、大型活動、婚禮、婚紗、人像、旅拍、生日、親子及時尚**等多元場景嘅影像拍攝服務。",
            },
            partnerships: {
                title: "品牌內容合作 | Creator Partnerships",
                moreLink: "了解更多",
                lead: "我哋目前已經簽約 **多位英國地區具有廣泛影響力嘅KOL同內容創作者**，覆蓋唔同內容領域同受眾圈層，並已經完成多品牌、多品類嘅品牌內容合作。",
                body: "依靠創作者資源同品牌合作經驗，我哋幫品牌搵啱內容夥伴，喺英國同中國市場建立真實、有影響力嘅品牌表達。",
                listTitle: "過往合作項目涵蓋：",
                items: [
                    "**品牌線下活動**｜邀請KOL參與品牌發佈會、推廣活動同大型線下活動，提升現場互動同社交傳播；",
                    "**活動主持同內容團隊**｜根據活動需求配對KOL主持人同創作者團隊，兼顧現場表現同線上傳播；",
                    "**產品推廣同品牌背書**｜根據品牌定位配對合適嘅頭部創作者，透過產品體驗、內容分享同社交媒體傳播提升品牌聲量；",
                    "**演唱會同文化娛樂合作**｜結合演唱會、文化活動等場景，策劃創作者參與同內容傳播；",
                    "**街頭互動同挑戰內容**｜透過街頭訪問、互動挑戰等形式，打造真實、自然且有傳播力嘅社交媒體內容。",
                ],
            },
            philosophy: {
                title: "品牌理念 | Our Philosophy",
                body: "我哋相信，**每一個行入鏡頭嘅個體，都有獨特而值得被睇見嘅精彩；\n 每一個走向海外嘅品牌，都值得擁有更廣闊嘅表達同被睇見嘅機會。**",
                closing: "由重要時刻嘅影像記錄，到品牌內容嘅策劃同傳播，\n 我哋以專業嘅影像能力、豐富嘅創作者資源同可靠嘅執行經驗，令每一次精彩都成為永恆。",
            },
            signature: {
                name: "**Sicheng Zhou**",
                roleEn: "*Head of Creative Content & Creator Partnerships*",
                roleZh: "創意內容與品牌合作負責人",
                brand: "**HEI CREATIVE | 巨能創意**",
            },
        },
        contact: {
            title: "聯絡",
            emailLabel: "電郵：",
            formIntro: "你都可以填寫下方表格，我會同你聯絡",
            firstName: "名",
            lastName: "姓",
            email: "電郵",
            date: "你希望幾時影相？",
            message: "請留言",
            submitted: "已提交！我會盡快同你聯絡！",
        },
        portfolio: {
            clickToExplore: "撳圖片可查看詳情",
            portrait: "人像攝影",
            wedding: "婚禮",
            event: "大型活動",
            commercial: "展會/商拍",
            pets: "寵物",
            fashion: "時尚",
            destination: "旅拍",
            creative: "創意",
            scenery: "風光",
        },
        creatorPartnerships: {
            heroEyebrow: "KOL 與創作者網絡",
            heroIntro: "我哋已經簽約多位喺英國地區具深遠影響力嘅KOL同優質內容創作者，精準覆蓋多元內容領域同核心受眾圈層，並已成功完成涵蓋多品牌、多品類嘅商業內容合作。",
            heroBody: "依靠豐富嘅創作者資源同累積嘅品牌合作經驗，我哋致力為品牌配對最啱嘅內容夥伴，喺英國同中國市場建立真實、有號召力嘅品牌表達。",
            sections: [
                {
                    title: "博主合作",
                    body: "我哋已經簽約多位喺英國地區具深遠影響力嘅KOL同優質內容創作者，精準覆蓋多元內容領域同核心受眾圈層，並已成功完成涵蓋多品牌、多品類嘅商業內容合作。依靠豐富嘅創作者資源同累積嘅品牌合作經驗，我哋致力為品牌配對最啱嘅內容夥伴，喺英國同中國市場建立真實、有號召力嘅品牌表達。",
                    image: "https://files.seeusercontent.com/2026/08/31/Bs3d/DSC00293-5-2.jpg",
                    alt: "博主合作",
                },
                {
                    title: "品牌線下活動",
                    body: "邀約優質KOL深度聯動品牌發佈會、快閃體驗同大型線下盛會，強化現場沉浸式互動，帶動社交媒體裂變傳播。",
                    image: "https://files.seeusercontent.com/2026/08/31/kx7I/23-D3emhE2b.jpg",
                    alt: "品牌線下活動",
                },
                {
                    title: "品牌線上推廣",
                    body: "根據品牌定位精準配對頭部創作者，透過深度產品體驗、優質內容創作同多平台社交傳播，全面賦能並提升品牌聲量。",
                    image: "https://files.seeusercontent.com/2026/08/31/hm8V/Creator-Content.png",
                    alt: "品牌線上推廣",
                },
                {
                    title: "多元化合作形式",
                    body: "探索豐富嘅內容合作維度，包括街頭隨機訪問、實地探店探廠、線上實時直播互動等，打造定制化嘅品牌傳播路徑。",
                    image: "https://files.seeusercontent.com/2026/08/31/ml0M/33-Bh5l7g1V.jpg",
                    alt: "多元化合作形式",
                },
            ],
        },
    },
    delivery: {
        meta: {
            invalidLink: "連結無效",
            expiredLink: "連結已過期",
            gallery: "相簿",
            consent: "知情同意",
        },
        consent: {
            agree: "繼續",
            leave: "離開",
            checkbox: "我已閱讀並知悉上述知情同意",
            checkRequired: "請閱讀知情同意",
            title: "相片交付 · 知情同意",
            social: {
                title: "相片發佈到社交媒體時，歡迎 @ 我，感謝你嘅出鏡！",
                copy: "複製用戶名",
                copied: "已複製",
                copyFailed: "複製失敗，請手動複製",
            },
            clauses: {
                thanks: "感謝你選擇 HEI CREATIVE 嘅攝影服務。以下為本批交付相片的瀏覽與使用須知，請在確認後繼續查看相簿。",
                sponsorIntro:
                    "本次活動相片由攝影師 HEI CREATIVE 免費拍攝並贊助。感謝大家的參與，歡迎將本相簿轉發畀所有參與者一齊欣賞。",
                expiry: "本連結設有有效期，過期後將無法訪問，請在倒數結束前完成瀏覽、揀片與下載。",
                commercial: "未經攝影師書面許可，不得將相片用於商業宣傳、二次售賣或授權第三方使用。",
                copyright: "相片版權歸攝影師所有。",
                colorGrading: "相片僅進行了初步調色，如需進一步精修或有任何後期問題，歡迎隨時聯絡攝影師。",
                shooting: "如你有拍攝需求，歡迎透過以下社交媒體聯絡到我，期待同你合作。",
                socialLabel: "展示社交媒體卡片",
            },
        },
        expired: {
            title: "連結已過期",
            body: "此連結已超過有效期。如需延期或重新獲取連結，請聯絡攝影師。",
            archiveBody: "你嘅相片已經歸檔儲存，歸檔儲存資訊如下：",
        },
        error: {
            title: "連結無效",
            subtitle: "無法解析此交付連結，請確認地址完整或聯絡攝影師重新獲取。",
        },
        countdown: {
            remaining: "剩餘",
            day: "天",
            hour: "小時",
            minute: "分",
            second: "秒",
        },
        actions: {
            pinned: "已置頂",
            download: "下載",
            downloadAll: "打包下載",
            downloadAllPhotos: "下載所有相片",
            downloadAllMobileTitle: "建議在電腦上下載",
            downloadAllMobileBody:
                "完整相簿體積较大，在手機端下載可能失敗或佔用大量記憶體。請在電腦上打開此連結後再下載所有相片。",
            downloadAllMobileContinue: "仍然下載",
            downloadAllFailed: "無法開始下載，請與攝影師聯絡。",
            downloadSelected: "下載所選",
            downloadSelectedPhotos: "下載相片",
            select: "選擇",
            selectAll: "全選本頁",
            selectAllPhotos: "全選圖片",
            selectFolderAll: "下載整個資料夾",
            selectedCount: "已揀",
            selectedFilesUnit: "個檔案",
            selectedPhotosUnit: "張相片",
            selectedFoldersUnit: "個資料夾",
            cancel: "取消",
            close: "關閉",
            previous: "上一張",
            next: "下一張",
            preview: "預覽",
            folderActions: "資料夾操作",
            backToParent: "返回上層資料夾",
            backToParentTitle: "返回上一層資料夾",
            downloading: "正在打包",
            downloadingPhotos: "正在下載",
            downloadConfirm: "將",
            downloadConfirmSuffix: "個檔案（含子資料夾）打包為 ZIP",
            downloadHint:
                "採用流式打包，適合電腦批量下載。部分檔案失敗時會自動重試，並在 ZIP 內附帶失敗列表。",
            zipPartialSuccess:
                "ZIP 已開始下載，{failed} 個檔案失敗，詳見壓縮包內 _download-failures.txt",
            mobileZipSuggestTitle: "建議在電腦上下載",
            mobileZipSuggestBody:
                "批量打包或資料夾下載在手機端可能佔用大量記憶體。請複製下方連結，在電腦瀏覽器中打開後再下載。",
            mobileZipContinue: "仍然在手機下載壓縮檔案",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            linkCopyFailed: "複製失敗，請手動複製",
            photosDownloadStarted: "已開始逐張下載",
            mobileSaveHint: "長按上方圖片，選擇「儲存到相片」",
            mobileBatchSaveTitle: "逐張儲存相片",
            mobileBatchSaveIntro: "向下滑動，長按每張圖片儲存到相簿",
            viewMode: "瀏覽方式",
            viewGrid: "瀏覽",
            viewWaterfall: "瀑布流",
            albumLoadFailed: "載入該相簿失敗，請與攝影師聯絡。",
            albumNotFound: "未找到該相簿，請確認連結是否正確，或聯絡攝影師。",
            contactPhotographer: "聯絡攝影師",
            retry: "重試",
            emptyFolder: "此資料夾為空",
            downloadFailed: "下載失敗",
            noFilesToDownload: "沒有可下載的檔案",
            countFilesFailed: "無法統計檔案數量",
            scanningFiles: "正在掃描檔案…",
            packingProgress: "正在打包 {current}/{total}{failedHint}…",
            failedHint: "（{count} 失敗）",
            zipDownloadStarted: "ZIP 已開始下載",
            zipDownloadFailed: "打包下載失敗",
            countingFiles: "正在統計檔案數量…",
            loadingText: "載入文字中…",
            textTooLarge: "檔案過大（超過 {size}KB），請下載後查看",
            textLoadFailed: "無法載入文字內容",
            previewUrlFailed: "無法獲取預覽地址",
            loadingAlbum: "載入相簿中…",
            loadMore: "載入更多",
            defaultAlbumName: "相簿",
            missingApiHint: "攝影師需部署 Cloudflare Worker 並設定 REACT_APP_DELIVERY_API_URL。",
            selectionFoldersPart: "，{folders} {unit}",
        },
        embed: {
            fileLoadFailed: "檔案載入失敗，請檢查網絡後重試。",
            loading: "載入中…",
        },
        api: {
            missingApi: "未設定交付 API 地址，請聯絡攝影師。",
        },
        downloadErrors: {
            cancelled: "已取消下載",
            noDownloadUrl: "無法獲取下載地址",
            httpFailed: "下載失敗（HTTP {status}）",
            missingUrl: "缺少下載地址",
            downloadFailed: "下載失敗",
            noFiles: "沒有可下載的檔案",
            apiNotConfigured: "未設定交付 API 地址",
            streamingUnsupported: "當前瀏覽器不支援流式下載，請使用 Chrome、Edge 或桌面版 Safari。",
            failureReportTitle: "下載失敗檔案列表",
            failureReportAlbum: "相簿: {name}",
            failureReportGenerated: "產生時間: {time}",
            failureReportCount: "共 {count} 個檔案",
            failureReportName: "檔案名: {name}",
            failureReportKey: "檔案路徑: {key}",
            failureReportError: "錯誤: {error}",
            failureReportReason: "原因码: {reason}",
            failureReportDomain: "域: {domain}",
            failureReportIndex: "序號: {index}/{total}",
            failureReportAttempts: "重試次数: {attempts}",
            failureReportBody: "响应摘要: {body}",
        },
        admin: {
            title: "交付",
            subtitle: "產生交付連結",
            description: "資料夾交付由 Cloudflare Worker 从 R2 读取，凭证不暴露在前端。",
            albumNameLabel: "相簿名稱",
            albumNamePlaceholder: "張三婚禮",
            albumNameHint: "將顯示在二維碼海報與分享頁面上，產生連結時必填。",
            albumNameRequired: "請輸入相簿名稱",
            pathLabel: "R2 交付路徑",
            pathPlaceholder: "wedding-zhang-san",
            pathHint: "运行 upload-delivery-to-r2.js 上載完成後，將脚本输出的路徑粘贴到此處。",
            pathRequired: "請輸入 R2 交付路徑",
            pathInvalid: "路徑格式無效，請檢查是否包含 ..、反斜杠或空的路徑段",
            expiryLabel: "有效期",
            archiveMarkdownLabel: "歸檔儲存說明（Markdown，可選）",
            archiveMarkdownPlaceholder:
                "例如：\n你嘅相片已經歸檔到：\n[打開歸檔相簿](https://example.com/archive)",
            archiveMarkdownHint: "可以先留空，之後透過編輯連結補填。支援任意文字同 Markdown 連結，過期後會顯示畀客戶睇。",
            consentLabel: "知情同意文案",
            consentHint: "勾選客戶打開連結時要展示的條款；一條都不勾選则跳過知情同意，直接進入相簿。",
            storageModeLabel: "連結形式",
            storageShort: "短鏈（落庫 D1）",
            storageInline: "自包含連結（base64）",
            storageShortHint:
                "詳情存入 D1，連結僅含随机短 ID，可在管理页編輯或刪除。",
            storageInlineHint:
                "老式方式：所有資訊 base64 編碼進連結，不落庫，因此無法在管理页編輯或撤銷，只能等其過期。",
            downloadAllLabel: "下載所有相片",
            downloadAllHint:
                "可选。設定後會在「選擇」旁顯示「下載所有相片」按钮。可填 R2 壓縮包（如 all.zip；不含斜杠時預設在相簿目錄下）或Google雲端硬碟檔案 ID。",
            downloadAllNone: "不啟用",
            downloadAllZip: "R2 壓縮包",
            downloadAllGdrive: "Google雲端硬碟",
            downloadAllZipPlaceholder: "all.zip",
            downloadAllGdrivePlaceholder: "Google雲端硬碟檔案 ID",
            downloadAllValueRequired: "請填寫壓縮包檔名或Google雲端硬碟檔案 ID",
            generate: "產生交付連結",
            resultTitle: "交付連結",
            expiresAt: "將於 {time}（你嘅本地時間）過期",
            viewCount: "訪問量：{count}",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗，請手動複製",
            expiryMustBeFuture: "過期時間須晚於當前時刻",
            generateFailed: "產生失敗，請檢查輸入",
            posterTitle: "二維碼海報",
            posterHint: "可下載或分享此海報，客戶掃碼即可打開相簿。",
            manageTitle: "交付連結管理",
            manageSubtitle: "此處僅顯示短鏈（已落庫 D1）。除主鍵 ID 外，所有參數均可編輯。",
            manageEmpty: "暫無交付連結。",
            manageLoadFailed: "載入交付連結失敗",
            expiredTag: "已過期",
            validTag: "有效",
            edit: "編輯",
            getPoster: "獲取海報",
            editTitle: "編輯交付連結",
            save: "儲存",
            editDone: "已儲存",
            editFailed: "儲存失敗",
            deleteConfirm: "確認刪除該交付連結？",
            deleteOk: "刪除",
            deleteCancel: "取消",
            deleteDone: "已刪除",
            deleteFailed: "刪除失敗",
        },
        share: {
            pageTitle: "分享相簿",
            shareButton: "分享",
            subtitle: "分享相簿",
            subtitleEn: "Share album",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗，請手動複製",
            downloadPoster: "下載二維碼海報",
            posterDownloaded: "海報已下載",
            posterDownloadFailed: "海報下載失敗",
            posterLoading: "正在產生海報…",
            posterFailed: "海報產生失敗",
            posterAlt: "{name} 的二維碼海報",
            urlLabel: "相簿連結",
            backToGallery: "返回相簿",
            poster: {
                subtitle: "相片交付",
                scanHint: "掃碼下載你嘅相片",
                expiryLabel: "相簿有效期至",
            },
        },
    },
    selection: {
        meta: {
            invalidLink: "連結無效",
            expiredLink: "連結已過期",
            gallery: "揀片相簿",
            consent: "揀片須知",
        },
        api: {
            missingApi: "未設定揀片 API 地址，請聯絡攝影師。",
        },
        consent: {
            agree: "我知道了，開始揀片",
            leave: "離開",
            checkbox: "我已閱讀並知悉上述知情同意",
            checkRequired: "請閱讀知情同意",
            title: "相片揀片 · 知情同意",
            social: {
                title: "相片發佈到社交媒體時，歡迎 @ 我，感謝你嘅出鏡！",
                copy: "複製用戶名",
                copied: "已複製",
                copyFailed: "複製失敗，請手動複製",
            },
            clauses: {
                thanks: "你好，歡迎嚟到 HEI CREATIVE 網上揀片。請閱讀以下條款後再開始揀選相片。",
                sponsorIntro:
                    "本次活動相片由攝影師 HEI CREATIVE 免費拍攝並贊助。多謝你嘅參與，歡迎將此揀片連結轉發畀所有參與者。",
                expiry: "本連結設有有效期，過期後將無法訪問，請喺到期前完成揀片並提交。",
                commercial: "未經攝影師書面許可，不得將相片用於商業宣傳、二次售賣或授權第三方使用。",
                copyright: "相片版權歸攝影師所有。",
                colorGrading: "相片僅進行了初步調色，如需進一步精修或有任何後期問題，歡迎隨時聯絡攝影師。",
                selectionQuality: "呢批相片只係初步調色相片，並非最終精修成片，唔代表最終成片質素。",
                shooting: "如你有拍攝需求，歡迎透過以下社交媒體聯絡到我，期待同你合作。",
                socialLabel: "展示社交媒體卡片",
            },
            variants: {
                general: {
                    title: "揀片須知",
                    paragraphs: [
                        "你好，歡迎嚟到 HEI CREATIVE 網上揀片。請填寫揀片人姓名後開始揀選你鍾意的相片。",
                        "1. 瀏覽時撳相片右上角的「+」即可加入揀片列表，揀選完成後請到揀片車撳「提交揀片」——揀完別忘了提交，否則攝影師收不到你嘅選擇。",
                        "2. 揀片結果會自動儲存在本裝置；使用同一個揀片人姓名再次進入時，會自動載入你之前揀過的相片，可繼續增減後再提交。",
                        "3. 連結設有有效期，過期後將無法訪問，請盡早完成揀片並提交。",
                    ],
                },
                sponsor: {
                    title: "活動揀片須知",
                    paragraphs: [
                        "你好！本次活動相片由攝影師 HEI CREATIVE 拍攝。請填寫姓名之後揀選你需要精修或留存的相片。",
                        "1. 瀏覽時撳相片右上角的「+」即可加入揀片列表，揀選完成後請到揀片車撳「提交揀片」——揀完別忘了提交，否則攝影師收不到你嘅選擇。",
                        "2. 揀片結果會自動儲存在本裝置；使用同一個姓名再次進入時，會自動載入你之前揀過的相片，可繼續增減後再提交。",
                        "3. 連結設有有效期，過期後將無法訪問，如有問題歡迎隨時聯絡攝影師。",
                    ],
                },
            },
        },
        name: {
            title: "請填寫揀片人姓名",
            subtitle: "姓名僅用于標識本次揀片，方便攝影師確認係邊個提交的。",
            placeholder: "請輸入你嘅姓名",
            required: "請填寫揀片人姓名",
            start: "開始揀片",
            back: "返回",
        },
        gallery: {
            defaultAlbumName: "相簿",
            loadingAlbum: "載入相簿中…",
            albumLoadFailed: "載入該相簿失敗，請與攝影師聯絡。",
            albumNotFound: "未找到該相簿，請確認連結是否正確，或聯絡攝影師。",
            missingApiHint: "攝影師需部署 Cloudflare Worker 並設定 REACT_APP_DELIVERY_API_URL。",
            contactPhotographer: "聯絡攝影師",
            retry: "重試",
            emptyFolder: "此資料夾為空",
            loadMore: "載入更多",
            backToParent: "返回上層資料夾",
            backToParentTitle: "返回上一層資料夾",
            download: "下載",
            downloading: "正在下載",
            downloadFailed: "下載失敗",
            close: "關閉",
            previous: "上一張",
            next: "下一張",
            addPick: "加入揀片",
            removePick: "移出揀片",
            pinned: "已置頂",
            viewCart: "已揀",
            downloadAllPhotos: "下載所有相片",
            goToCart: "查看已揀並提交",
            selectedCount: "已揀 {count} 張相片",
            restored: "已自動載入你上次選擇的 {count} 張相片",
            noteLabel: "修圖指引（選填）",
            notePlaceholder: "寫低對呢張相片的修圖要求，例如：磨皮、調亮膚色、去除背景路人……",
            noteHint: "填寫修圖指引會自動把呢張相片加入揀片。",
            noteSave: "儲存修圖指引",
            noteSaved: "修圖指引已儲存",
            noteSubmitReminder: "別忘了提交揀片結果哦",
            saveFailed: "本機儲存唔可用，呢次修改未保存，刷新或退出後可能會丟失，請盡快提交揀片。",
        },
        cart: {
            title: "我的揀片",
            summary: "{name} · 已揀 {count} 張",
            anonymous: "揀片人",
            continue: "繼續揀片",
            empty: "仲未選擇任何相片",
            goSelect: "去揀片",
            remove: "移除",
            clear: "清空",
            clearConfirm: "確認清空已揀相片？",
            clearOk: "清空",
            clearCancel: "取消",
            submit: "提交揀片",
            submitHint: "提交後攝影師將收到你嘅揀片結果。提交前可繼續新增或移除相片。",
            submitDone: "揀片已提交",
            submitFailed: "提交失敗，請重試",
            expired: "連結已過期，無法提交",
            needName: "請先填寫揀片人姓名",
            successTitle: "揀片已提交",
            successSubtitle: "感謝 {name}！你已成功提交 {count} 張相片，攝影師會盡快處理。",
            backToGallery: "返回相簿",
            note: "修圖指引",
            noteAdd: "新增修圖指引",
            noteEditTitle: "修圖指引",
            notePlaceholder: "寫低對呢張相片的修圖要求，例如：磨皮、調亮膚色、去除背景路人……",
            noteSave: "儲存",
            noteCancel: "取消",
            noteSaved: "修圖指引已儲存",
        },
        admin: {
            title: "揀片",
            subtitle: "產生揀片連結",
            description: "揀片連結詳情存入 D1，客戶揀選後提交的結果可在揀片結果页查看。",
            albumNameLabel: "相簿名稱",
            albumNamePlaceholder: "張三婚禮",
            albumNameHint: "將顯示在揀片頁面上，產生連結時必填。",
            albumNameRequired: "請輸入相簿名稱",
            pathLabel: "R2 相簿路徑",
            pathPlaceholder: "wedding-zhang-san",
            pathHint: "與交付相簿相同：上載到 R2 後，將脚本输出的路徑粘贴到此處。",
            expiryLabel: "有效期",
            archiveMarkdownLabel: "歸檔儲存說明（Markdown，可選）",
            archiveMarkdownPlaceholder:
                "例如：\n你嘅相片已經歸檔到：\n[打開歸檔相簿](https://example.com/archive)",
            archiveMarkdownHint: "可選。之後可以透過編輯連結補填，支援任意文字同 Markdown 連結；揀片連結過期後會顯示畀客戶睇。",
            consentLabel: "知情同意文案",
            consentHint: "勾選客戶打開揀片連結時要展示的條款；一條都不勾選就會跳過知情同意，直接進入揀片。",
            downloadAllLabel: "下載所有相片",
            downloadAllHint:
                "可選。設定後會喺揀片車旁邊顯示「下載所有相片」按鈕。可填 R2 壓縮包物件（如 all.zip；不含斜杠時預設喺相簿目錄下）或 Google 雲端硬碟檔案 ID。",
            downloadAllNone: "不啟用",
            downloadAllZip: "R2 壓縮包",
            downloadAllGdrive: "Google 雲端硬碟",
            downloadAllZipPlaceholder: "all.zip",
            downloadAllGdrivePlaceholder: "Google 雲端硬碟檔案 ID",
            downloadAllValueRequired: "請填寫壓縮包檔名或 Google 雲端硬碟檔案 ID",
            consentGeneral: "通用版",
            consentSponsor: "活動版",
            generate: "產生揀片連結",
            generateFailed: "產生失敗，請檢查輸入",
            resultTitle: "揀片連結",
            expiresAt: "將於 {time}（你嘅本地時間）過期",
            viewCount: "訪問量：{count}",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗，請手動複製",
            expiryMustBeFuture: "過期時間須晚於當前時刻",
            posterTitle: "二維碼海報",
            posterHint: "可下載或分享此海報，客戶掃碼即可打開揀片相簿。",
            manageTitle: "揀片連結管理",
            manageSubtitle: "此處管理已產生的揀片連結，除主鍵 ID 外所有參數均可編輯。",
            manageEmpty: "暫無揀片連結。",
            manageLoadFailed: "載入揀片連結失敗",
            viewResults: "查看揀片結果",
            expiredTag: "已過期",
            validTag: "有效",
            edit: "編輯",
            getPoster: "獲取海報",
            editTitle: "編輯揀片連結",
            save: "儲存",
            editDone: "已儲存",
            editFailed: "儲存失敗",
            deleteConfirm: "確認刪除該揀片連結？",
            deleteOk: "刪除",
            deleteCancel: "取消",
            deleteDone: "已刪除",
            deleteFailed: "刪除失敗",
        },
        share: {
            subtitle: "揀片相簿",
            subtitleEn: "Photo selection",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗，請手動複製",
            downloadPoster: "下載二維碼海報",
            posterDownloaded: "海報已下載",
            posterDownloadFailed: "海報下載失敗",
            posterLoading: "正在產生海報…",
            posterFailed: "海報產生失敗",
            posterAlt: "{name} 的揀片二維碼海報",
            urlLabel: "揀片連結",
            poster: {
                subtitle: "揀片相簿",
                scanHint: "掃碼開始揀相",
                expiryLabel: "相簿有效期至",
            },
        },
        results: {
            title: "揀片結果",
            subtitle: "查看客戶提交的揀片結果，按相簿分类展示；支援搜尋、時間篩選與分頁，詳情按需載入。",
            loadFailed: "載入揀片結果失敗",
            detailLoadFailed: "載入揀片詳情失敗",
            detailLoading: "載入揀片詳情…",
            refresh: "刷新",
            search: "查詢",
            resetFilters: "重設",
            searchPlaceholder: "搜尋揀片人、相簿名稱或路徑",
            dateFrom: "開始日期",
            dateTo: "結束日期",
            empty: "暫無揀片結果。",
            emptyFiltered: "沒有符合條件的揀片結果。",
            unknownAlbum: "未分類相簿",
            albumSubmissionCount: "{count} 條揀片記錄",
            pageRange: "第 {from}–{to} 條",
            hasMoreSuffix: "（可能還有更多）",
            photoCount: "{count} 張",
            submittedAt: "提交於 {time}",
            view: "查看",
            deleteConfirm: "確認刪除該揀片記錄？",
            deleteOk: "刪除",
            deleteCancel: "取消",
            deleteDone: "已刪除",
            deleteFailed: "刪除失敗",
            detailTitle: "{name} 的揀片",
            albumLabel: "相簿",
            copyPaths: "複製相片路徑",
            pathsCopied: "已複製相片路徑",
            copyFailed: "複製失敗，請手動複製",
            close: "關閉",
            note: "修圖指引",
            copyNotes: "複製修圖指引",
            notesCopied: "已複製修圖指引",
            noNotes: "本次揀片沒有填寫修圖指引",
            exportCsv: "匯出 CSV",
            exportDone: "已匯出 CSV",
            exportFailed: "匯出失敗",
            csvIndex: "序號",
            csvName: "檔案名",
            csvPath: "路徑",
            csvNote: "修圖指引",
        },
    },
    videoReview: {
        api: {
            missingApi: "影片評價 API 未設定，請設定 REACT_APP_DELIVERY_API_URL。",
        },
        consent: {
            agree: "繼續",
            leave: "離開",
            checkbox: "我已閱讀並知悉上述知情同意",
            checkRequired: "請閱讀知情同意",
            title: "影片交付 · 知情同意須知",
            social: {
                title: "當你將影片發佈到社交媒體嘅時候，歡迎 @ 我，感謝你嘅出鏡！",
                copy: "複製用戶名",
                copied: "已複製",
                copyFailed: "複製失敗，請手動複製",
            },
            clauses: {
                thanks: "感謝你選擇 HEI CREATIVE 嘅攝影服務。以下為本支交付影片的瀏覽與評價須知，請在確認後繼續觀看並留下修改意見。",
                sponsorIntro:
                    "本次活動影片由攝影師 HEI CREATIVE 免費拍攝並贊助。感謝大家的參與，歡迎將本連結轉發畀所有參與者一齊觀看評價。",
                expiry: "本連結設有有效期，過期後將無法訪問，請在倒數結束前完成觀看與評價。",
                commercial: "未經攝影師書面許可，不得將影片用於商業宣傳、二次售賣或授權第三方使用。",
                copyright: "影片版權歸攝影師所有。",
                colorGrading:
                    "影片僅進行了初步調色與剪輯。如需進一步修改，歡迎隨時聯絡攝影師，或在對應時間點留言評價。",
                shooting: "如你有拍攝需求，歡迎透過以下社交媒體聯絡到我，期待同你合作。",
                socialLabel: "展示社交媒體卡片",
            },
        },
        name: {
            title: "請填寫你嘅姓名",
            subtitle: "姓名僅用于標識評論來源，方便攝影師確認係邊個提交的。",
            placeholder: "請輸入你嘅姓名",
            required: "請填寫姓名",
            start: "開始評價",
            back: "返回",
        },
        gallery: {
            defaultVideoName: "影片",
            notFound: "未找到該連結，請確認地址是否正確，或聯絡攝影師。",
            loadFailed: "載入影片評價連結失敗，請重試。",
            videoMissing: "未找到影片檔案，請聯絡攝影師。",
        },
        download: {
            button: "下載影片",
            downloading: "正在準備下載",
            started: "已開始下載",
            failed: "下載失敗，請稍後重試",
            confirmTitle: "確認下載影片？",
            confirmBody: "影片檔案較大，建議唔好喺手機上下載。",
            confirmOk: "仍然下載",
        },
        comments: {
            title: "評論",
            empty: "暫無評論。暫停影片後，可在當前時間點留下修改意見。",
            placeholder: "寫低此處需要修改的內容……",
            submit: "發表評論",
            posted: "評論已發表",
            postFailed: "發表評論失敗",
            loadFailed: "載入評論失敗",
            expired: "連結已過期，無法繼續評論",
            atTime: "將在 {time} 处評論",
            individualHint: "僅顯示你嘅評論",
            delete: "刪除評論",
            deleteConfirm: "確定刪除呢條評論？",
            deleted: "評論已刪除",
            deleteFailed: "刪除評論失敗",
        },
        admin: {
            title: "影片評價",
            subtitle: "建立影片評價連結",
            description:
                "分享單個交付影片，客戶可隨時暫停並在對應時間點留下修改意見，精確到毫秒。",
            manageTitle: "管理影片評價",
            manageSubtitle: "編輯、複製或刪除影片評價連結。",
            manageEmpty: "暫無影片評價連結",
            manageLoadFailed: "載入影片評價連結失敗",
            searchPlaceholder: "搜尋影片名稱",
            pageRange: "第 {from}–{to} 條，共 {total} 條",
            viewResults: "查看評論",
            videoNameLabel: "影片名稱",
            videoNamePlaceholder: "張三婚禮 — 成片 v1",
            videoNameHint: "將顯示在評價頁面上。",
            videoNameRequired: "請輸入影片名稱",
            pathLabel: "R2 影片路徑",
            pathPlaceholder: "client/wedding/final.mp4",
            pathHint: "R2 上的單個影片檔案 key（需先手動上載）。",
            pathRequired: "請輸入影片路徑",
            pathInvalid: "影片路徑無效",
            consentHint: "勾選客戶打開連結時要展示的條款；一條都不勾選则跳過知情同意，直接進入評價页面。",
            expiryLabel: "連結有效期",
            expiryMustBeFuture: "過期時間須在未來",
            consentLabel: "知情同意類型",
            consentGeneral: "通用",
            consentSponsor: "贊助",
            visibilityLabel: "評論可見性",
            visibilityShared: "全員可見",
            visibilityIndividual: "各自可見",
            visibilitySharedHint: "同一連結下，所有評價者都能睇到全部評論。",
            visibilityIndividualHint: "每位評價者只能睇到自己嘅評論；管理员可在後台查看全部。",
            generate: "產生連結",
            generateFailed: "產生連結失敗",
            resultTitle: "連結已產生",
            expiresAt: "有效期至 {time}",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗",
            edit: "編輯",
            editTitle: "編輯影片評價連結",
            editDone: "已儲存",
            editFailed: "儲存失敗",
            save: "儲存",
            deleteConfirm: "確定刪除此連結及全部評論？",
            deleteOk: "刪除",
            deleteCancel: "取消",
            deleteDone: "已刪除",
            deleteFailed: "刪除失敗",
            expiredTag: "已過期",
            validTag: "有效",
            viewCount: "訪問量：{count}",
            commentCount: "評論總數：{count}",
            posterTitle: "二維碼海報",
            posterHint: "可下載或分享此海報，客戶掃碼即可打開影片評價页面。",
            getPoster: "獲取海報",
        },
        share: {
            subtitle: "影片評價",
            subtitleEn: "Video review",
            copyLink: "複製連結",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗，請手動複製",
            downloadPoster: "下載二維碼海報",
            posterDownloaded: "海報已下載",
            posterDownloadFailed: "海報下載失敗",
            posterLoading: "正在產生海報…",
            posterFailed: "海報產生失敗",
            posterAlt: "{name} 的影片評價二維碼海報",
            urlLabel: "影片評價連結",
            poster: {
                subtitle: "影片評價",
                scanHint: "掃碼觀看並留低帶時間戳嘅意見",
                expiryLabel: "評價連結有效期至",
            },
        },
        audit: {
            badge: "管理员审核",
            reviewButton: "审核評論",
            backToManage: "返回管理",
            allCommentsHint: "顯示全部評論",
        },
        results: {
            title: "影片評價評論",
            subtitle: "查看帶時間戳的修改意見，並可匯出為字幕檔案供剪輯使用。",
            selectLink: "選擇影片連結",
            loadFailed: "載入評論失敗",
            noComments: "該連結暫無評論",
            copyAll: "複製全部",
            allCopied: "評論已複製",
            timestampCopied: "時間戳已複製",
            exportCsv: "匯出 CSV",
            exportSrt: "匯出 SRT",
            exportVtt: "匯出 VTT",
            exportSubtitle: "匯出字幕",
            exportDone: "檔案已下載",
            exportFailed: "匯出失敗",
            colTimestamp: "時間戳",
            colReviewer: "評論者",
            colBody: "評論內容",
            colSubmittedAt: "提交時間",
            colActions: "操作",
        },
    },
    retouchReview: {
        admin: {
            title: "精修審核",
            manageTitle: "精修審核管理",
        },
    },
    fileTransfer: {
        admin: {
            title: "文件傳輸",
            manageTitle: "文件傳輸管理",
            fieldTitle: "標題 *",
            fieldTitlePlaceholder: "例如：項目文件交付、設計稿收集",
            fieldTitleHint: "幫呢次傳輸會話改個名，方便識別",
            fieldDescription: "描述",
            fieldDescriptionPlaceholder: "可選：加啲說明文字，打開連結嘅人會睇到",
            fieldExpiry: "到期時間",
            day: "1 日",
            days: "{days} 日",
            fieldMaxFileSize: "單檔案大小限制",
            bytes: "字節",
            maxFileSizeHint: "目前設置：{size}，最多可設 5TB",
            fieldMaxFiles: "檔案數量上限",
            maxFilesHint: "最多 10000 個檔案",
            createButton: "建立傳輸連結",
            resultTitle: "傳輸連結已建立",
            resultDesc: "打開呢個連結嘅人可以上傳檔案，都可以下載所有已上傳嘅檔案",
            copyLink: "複製連結",
            preview: "預覽",
            successCreated: "傳輸會話已建立",
            subtitle: "建立一個檔案傳輸會話，生成一個同時支援上傳同下載嘅連結",
            createFailed: "建立失敗",
            linkCopied: "連結已複製",
            copyFailed: "複製失敗",
        },
        manage: {
            title: "文件傳輸管理",
            subtitle: "管理所有文件傳輸會話",
            noSessions: "暫無傳輸會話",
            edit: "編輯",
            editTitle: "編輯傳輸會話",
            save: "保存",
            cancel: "取消",
            saved: "已更新",
            saveFailed: "保存失敗",
            deleteConfirmTitle: "確認刪除呢個傳輸會話？",
            deleteConfirmDesc: "以下內容將被永久刪除且不可恢復：該會話下嘅 {count} 個檔案（共 {size}）以及所有傳輸記錄。",
            deleteOk: "確認刪除",
            deleteCancel: "取消",
            deleteDone: "已刪除傳輸會話{extra}",
            deleteFailed: "刪除失敗",
            expired: "已過期",
            loadFailed: "載入失敗",
            noTitle: "(無標題)",
            copied: "連結已複製",
        },
        session: {
            title: "文件傳輸",
            expired: "連結已過期",
            expiredDesc: "{title} 已過期",
            backHome: "返回首頁",
            loading: "載入中...",
            loadFailed: "載入失敗",
            timeLeft: "剩餘 {time}",
            limits: "單檔案上限 {size}，最多 {count} 個檔案",
            uploadSection: "上傳檔案",
            uploadText: "點擊或拖拽檔案到呢度上傳",
            uploadHint: "支援任意格式，單檔案最大 {size}",
            uploadSuccess: "{name} 上傳完成",
            uploadFailed: "{name} 上傳失敗: {msg}",
            uploadRetryHint: "請重新選擇 \"{name}\"",
            networkError: "網絡錯誤",
            partFailed: "分片上傳失敗: {msg}",
            fileSection: "已上傳檔案",
            noFiles: "暫無已上傳嘅檔案",
            downloadAll: "打包下載 ZIP",
            downloadAllDone: "下載完成",
            downloadAllFailed: "下載失敗: {msg}",
            downloadAllWarn: "冇可以下載嘅檔案",
            downloadAllUnsupported: "目前瀏覽器唔支援打包下載，請改用下面嘅單檔案下載按鈕",
            downloadAllPartial: "打包完成：成功 {succeeded} 個，失敗 {failed} 個，失敗清單已經包含喺 ZIP 入面",
            downloadStart: "開始下載，請喺瀏覽器下載管理中查看進度",
            downloadFailed: "下載失敗: {msg}",
            streamFailed: "串流下載失敗",
            fileNotReady: "檔案尚未就緒",
            deleteConfirm: "確認刪除",
            deleteConfirmDesc: "確定要刪除 {name} 嗎？呢個操作唔可以恢復。",
            deleteDone: "{name} 已刪除",
            deleteFailed: "刪除失敗: {msg}",
            zipProgress: "下載中: {current}/{total}",
            zipProgressFailed: "，失敗 {count} 個",
            zipDone: "下載完成",
            cancelled: "已取消",
        },
        form: {
            titleRequired: "請輸入標題",
            titleTooLong: "標題過長",
            descTooLong: "描述過長",
            expiryRequired: "請設定到期時間",
            expiryMustBeFuture: "到期時間必須喺未來",
            maxFileSizeInvalid: "單檔案大小限制無效（1B – 5TB）",
            maxFilesInvalid: "檔案數量限制無效（1 – 10000）",
        },
    },

    feedback: {
        prompt: "有反饋？",
        link: "請點我",
        api: {
            missingApi: "反饋 API 未配置，請設置 REACT_APP_DELIVERY_API_URL。",
        },
        modal: {
            title: "提交反饋",
            contentPlaceholder: "請寫下您想說的話……",
            contactPlaceholder: "聯絡方式（選填，電郵或電話）",
            contentRequired: "請填寫反饋內容",
            submit: "提交",
            cancel: "取消",
            success: "感謝您的反饋！",
            error: "提交失敗，請稍後重試",
        },
        admin: {
            title: "用戶反饋",
            subtitle: "查看客戶在交付相冊與選片頁面提交的反饋。",
            searchPlaceholder: "搜尋內容、相冊、聯絡方式或 IP",
            dateFrom: "開始日期",
            dateTo: "結束日期",
            search: "搜尋",
            resetFilters: "重設篩選",
            refresh: "重新整理",
            empty: "暫無反饋",
            emptyFiltered: "沒有符合篩選條件的反饋",
            sourceDelivery: "交付",
            sourceSelection: "選片",
            submittedAt: "提交於 {time}",
            view: "查看",
            detailTitle: "反饋詳情",
            deleteConfirm: "確定刪除這條反饋？",
            deleteOk: "刪除",
            deleteCancel: "取消",
            deleted: "已刪除",
            deleteFailed: "刪除失敗",
            loadFailed: "載入反饋失敗",
            exportCsv: "匯出 CSV",
            exportDone: "已匯出 CSV",
            exportFailed: "匯出失敗",
            pageRange: "第 {from}-{to} 條",
            hasMoreSuffix: "（可能還有更多）",
            colTime: "時間",
            colSource: "來源",
            colAlbum: "相冊",
            colLinkId: "短鏈 ID",
            colContent: "內容",
            colContact: "聯絡方式",
            colIp: "IP",
            colActions: "操作",
            unknownAlbum: "未知相冊",
            allSources: "全部來源",
            albumPath: "相冊路徑",
        },
    },
    quote: {
        page: {
            title: "報價單",
            subtitle: "填寫項目費用明細，產生可分享的報價單圖片。",
            preview: "預覽報價單",
            reset: "重設表格",
            resetDone: "表格已重設",
        },
        form: {
            basicInfo: "基礎資訊",
            lineItems: "費用明細",
            projectName: "客戶名稱 / 項目名稱",
            projectNamePlaceholder: "張三婚禮",
            quoteDate: "報價日期",
            validUntil: "報價有效期",
            currency: "整單幣種",
            portfolioUrl: "樣片連結",
            portfolioUrlPlaceholder: "https://heicreative.co.uk",
            globalNotes: "全域備註",
            globalNotesHint: "每條備註單獨一行，將顯示在報價單底部。",
            globalNotePlaceholder: "輸入備註",
            addNote: "新增備註",
            removeNote: "刪除",
            itemName: "項目名稱",
            itemNamePlaceholder: "婚禮跟拍",
            unitPrice: "單價",
            quantity: "數量",
            note: "備註",
            notePlaceholder: "如：含後期 50 張精修",
            subtotal: "小计",
            addLine: "新增一行",
            removeLine: "刪除此行",
            grandTotal: "報價總計",
            hideSubitemPrices: "隱藏所有子項報價",
        },
        categories: {
            photography: "拍攝費用",
            equipment: "器材費用",
            travel: "差旅",
            other: "其他",
        },
        validation: {
            projectNameRequired: "請輸入客戶名稱或項目名稱",
            quoteDateRequired: "請選擇報價日期",
            portfolioUrlInvalid: "樣片連結格式無效，請輸入 http 或 https 開頭的網址",
        },
        preview: {
            downloadPoster: "下載報價單圖片",
            openPoster: "產生報價單圖片",
            posterDownloaded: "報價單已下載",
            posterDownloadFailed: "報價單產生失敗",
            posterLoading: "正在產生報價單…",
            posterFailed: "報價單產生失敗",
            imageTabTitle: "報價單",
            saveSheetHint: "喺分享面板中選擇「儲存影像」即可儲存到相簿。",
            saveToPhotos: "儲存到相簿",
            openImage: "喺瀏覽器中開啟",
            longPressHint: "亦可以長按圖片儲存到相簿",
            closePreview: "關閉",
        },
        poster: {
            title: "報價單",
            titleEn: "QUOTATION",
            projectPlaceholder: "項目名稱",
            validUntil: "有效期至",
            colItem: "項目",
            colCalc: "單價×數量",
            colAmount: "小计",
            sectionSubtotal: "小计",
            grandTotal: "合计 TOTAL",
            scanZh: "掃碼查看樣片",
            scanEn: "Scan for portfolio",
            socialRed: "小红书 @倫敦攝影師小黑",
            socialIg: "Instagram @Mr.Hei_",
        },
    },
    booking: {
        panel: {
            title: "後台",
            subtitle: "已登入。",
            signOut: "退出登入",
        },
        admin: {
            title: "預約單管理",
            subtitle: "新增預約攝影單，產生帶二維碼的海報，客戶掃碼即可在官網查看預約資訊。",
            new: "新增預約單",
            empty: "仲未有預約單，撳右上角新增。",
            poster: "海報",
            posterTitle: "預約海報",
            copyLink: "複製連結",
            createdAt: "建立於",
            loadFailed: "載入預約單失敗",
            createDone: "預約單已建立",
            createFailed: "建立失敗，請重試",
            linkCopied: "連結已複製",
            deleteConfirm: "確定刪除該預約單？",
            deleteOk: "刪除",
            deleteCancel: "取消",
            deleteDone: "已刪除",
            deleteFailed: "刪除失敗",
            searchPlaceholder: "搜尋名稱、地點、內容或 ID",
            dateFrom: "拍攝開始",
            dateTo: "拍攝結束",
            search: "搜尋",
            resetFilters: "重置篩選",
            refresh: "重新整理",
            emptyFiltered: "冇符合篩選條件嘅預約單",
            pageRange: "第 {from}–{to} 條",
            hasMoreSuffix: "（可能仲有更多）",
        },
        form: {
            title: "預約單名稱",
            titlePlaceholder: "如：張先生婚禮跟拍",
            titleRequired: "請輸入預約單名稱",
            location: "地點",
            locationPlaceholder: "如：倫敦 XX 教堂",
            locationRequired: "請輸入拍攝地點",
            shootAt: "拍攝時間",
            shootAtPlaceholder: "選擇日期與時間",
            shootAtRequired: "請選擇拍攝時間",
            shootAtLocalHint: "請按拍攝地當地時間填寫。",
            shootAtHour: "時",
            shootAtMinute: "分",
            duration: "拍攝時长",
            durationPlaceholder: "選填，如：2 小時 / 全天",
            content: "拍攝內容",
            contentPlaceholder: "描述本次拍攝內容、人數、特殊要求等",
            contentRequired: "請填寫拍攝內容",
            notes: "備註",
            notesPlaceholder: "選填，如：著裝要求、泊車資訊等",
            submit: "建立並產生海報",
        },
        poster: {
            title: "預約確認",
            titleEn: "BOOKING",
            titlePlaceholder: "預約單名稱",
            time: "時間",
            localTime: "顯示拍攝時間均為當地時間",
            duration: "時长",
            location: "地點",
            content: "內容",
            notes: "備註",
            scanZh: "掃碼查看預約詳情",
            scanEn: "Scan to view booking",
            downloadPoster: "下載海報",
            openPoster: "產生海報",
            downloaded: "海報已下載",
            downloadFailed: "海報下載失敗",
            loading: "正在產生海報…",
            failed: "海報產生失敗",
            longPressHint: "長按圖片儲存到相簿",
            closePreview: "關閉",
        },
        view: {
            loading: "正喺度載入…",
            notFoundTitle: "預約不存在或已失效",
            notFoundText: "請確認連結是否正確，或聯絡攝影師。",
            networkErrorTitle: "載入失敗",
            networkErrorText: "網絡似乎不太穩定，暫時無法載入預約資訊。",
            troubleshootHint: "請嘗試清理快取 / 切換網絡 / 使用預設瀏覽器打開。",
            contactPrompt: "仍然無法載入？",
            contactLink: "聯絡我",
            debugToggle: "技術詳情",
        },
    },
};

export default yue;
